<template>
  <div class="advice-overview-page">
    <fn-section
      class="show-m"
      constrained="l"
      padding-top="xs"
      padding-bottom="xs"
    >
      <fn-breadcrumbs :nodes="page.content.breadcrumbs" />
    </fn-section>

    <fn-section
      class="hide-m"
      background-color="sand-light"
      padding-top="xxs"
      padding-bottom="xxs"
      sub-section
    >
      <fn-slider-navigation
        v-if="nodes && nodes.nodes"
        :nodes="nodes.nodes"
      />
    </fn-section>

    <fn-section
      constrained="l"
      padding-top="xs"
      padding-bottom="xs"
    >
      <fn-grid>
        <fn-grid-item
          class="sidebar show-m"
          columns="12"
          columns-m="3"
        >
          <fn-sidebar-navigation
            v-if="nodes && nodes.nodes"
            :nodes="nodes.nodes"
          />

          <fn-cms-section-loader
            v-if="page.content.content_slots.a && page.content.content_slots.a.sections"
            :sections="page.content.content_slots.a.sections"
            :sub-sections="true"
          />
        </fn-grid-item>
        <fn-grid-item
          columns="12"
          columns-m="9"
        >
          <fn-section
            padding-bottom="xs"
            no-padding-x
          >
            <fn-cms-section-loader
              v-if="page.content.content_slots && page.content.content_slots.b && page.content.content_slots.b.sections"
              :sections="page.content.content_slots.b.sections"
            />
          </fn-section>
        </fn-grid-item>
      </fn-grid>
    </fn-section>

    <fn-section no-padding>
      <fn-grid>
        <fn-grid-item
          columns="12"
          columns-m="12"
        >
          <fn-section
            padding-bottom="xs"
            no-padding-x
          >
            <fn-cms-section-loader
              v-if="page.content.content_slots && page.content.content_slots.c && page.content.content_slots.c.sections"
              :sections="page.content.content_slots.c.sections"
            />
          </fn-section>
        </fn-grid-item>
      </fn-grid>
    </fn-section>
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    page: Record<string, any>;
    nodes?: Record<string, any>;
  }>(),
  {
    nodes: () => ({}),
  },
);

const route = useRoute();
useScrollToHash(route);
</script>

<style lang="scss" scoped>
.advice-article-page {
  font-size: 18px;
  line-height: 28px;

  .breadcrumbs {
    border-bottom: none;
  }
}
</style>
